import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function usePaymentMethods() {
    const { data } = useQuery(queries.paymentMethod.list());
    return data?.paymentMethods;
}

export default usePaymentMethods;
